import { EventDefinition } from 'redux-beacon'
import { interactions } from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import { userClickEvents } from '@chegg-wt/core/state/instrumentation/rio/definitions'

export const citationCreationFlowEvent: EventDefinition = (action) => {
  const { citation, citationMetadata } = action.payload
  const { source } = citation
  const transformedAction = interactions.citationsFlowClickCreate(
    source,
    citationMetadata
  )

  return userClickEvents(transformedAction)
}
